'use client'

import Image from 'next/image'
import PlayAudioButton from '@/components/PlayAudioButton'

export default function KnownFromStrip() {
  return (
    <div className="w-full py-4 md:py-0">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 lg:px-10">
        <div className="flex items-center justify-center gap-2 py-4 md:gap-4 md:py-5">
          <span className="leading-none font-semibold text-gray-900 md:text-[18px]">
            Bekannt aus:
          </span>

          {/* Recreated logo */}
          <div className="relative h-12 w-[150px] md:h-20 md:w-[210px]">
            <Image
              src="/images/Berliner_Rundfunk_91.4_Logo_2018.svg.png"
              alt="Berliner Rundfunk 91.4"
              fill
              className="object-contain"
              sizes="210px"
            />
          </div>

          {/* Play button */}
          <div className="ml-1">
            <PlayAudioButton
              src="/audio/Funkspot_Solar Germany eood (10 Sek).mp3"
              ariaLabel="Berliner Rundfunk Spot abspielen"
              size={48}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
